import { XCircle } from "lucide-react";
import { problems, PARKING_BG } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

export const Problem = () => (
  <section id="problem" data-testid="problem-section" className="relative py-28 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-16 items-center">
      <Reveal>
        <Overline>The Problem</Overline>
        <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
          Parking is <span className="text-brand-green">broken.</span>
        </h2>
        <ul className="mt-8 space-y-4">
          {problems.map((p, i) => (
            <li key={i} className="flex items-start gap-3">
              <XCircle className="h-5 w-5 text-red-400 mt-0.5 shrink-0" />
              <span className="text-white/75">{p}</span>
            </li>
          ))}
        </ul>
        <p className="mt-8 font-heading font-bold text-2xl text-red-400">
          Billions in inefficiency. Every single day.
        </p>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative rounded-2xl overflow-hidden border border-white/10">
          <img src={PARKING_BG} alt="Parking structure at night" className="w-full h-[420px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
        </div>
      </Reveal>
    </div>
  </section>
);
